import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'

interface SVGRProps {
  title?: string
  titleId?: string
}
const SpeleologyIcon = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    viewBox="0 0 256 256"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M166.6,59.9c0,10.2-8.3,18.5-18.4,18.5c-6.3,0-11.8-3.2-15.1-7.9h5.8c3.9,0,7.2-2.3,8.8-5.5l2.5-5.4c0.2-0.3,0.5-0.6,0.9-0.6h15.5V59.9z" />
    <path d="M170.1,54.2c-2.5-9.8-11.4-17-22-17c-12.6,0-22.7,10.2-22.7,22.7c0,2.1,0.3,4.1,0.8,5.9h12.6c2,0,3.8-1.2,4.6-2.9l2.4-5.4c0.9-2,2.9-3.3,5.2-3.3H170.1z" />
    <path d="M104.8,70.6c2.3-1.9,2.6-5.2,0.8-7.4L95.6,51c-1.8-2.3-5.2-2.6-7.4-0.8L45.7,84.8c-2.2,1.8-2.6,5.2-0.8,7.5l10,12.2c1.8,2.2,5.2,2.6,7.5,0.8L104.8,70.6z" />
    <path d="M62.8,119.6c-2.4,1.8-4.5,4.2-6,7c-1.5,2.7-2.4,5.5-2.9,8.3l-12.1,52.3L8.3,219.3c-0.9,0.9-1.7,1.8-2.3,3c-3.5,6.1-1.4,14,4.8,17.5c4.9,2.8,11,2,15-1.7l37.2-35.9c0.5-0.7,1-1.4,1.5-2.1c0.5-1,1-2,1.3-3l7.6-33.1l24.9,24.8L98,230.6c0,4.5,2.3,8.8,6.5,11.1c6.1,3.5,14,1.4,17.5-4.8c1.2-2.2,1.7-4.6,1.6-6.9l0.1-46.5c0.1-3.3-1.1-6.6-3.4-9.1L93.5,148l30.8-25.3l7.1,19.7c0.6,1.3,1.5,2.5,2.7,3.4l29.5,22.4c4,2.4,9.3,1.8,12.6-1.7c3.8-4.1,3.6-10.5-0.5-14.3c-0.1-0.1-0.3-0.2-0.4-0.3l-25.8-19.7l-12-35.1c-1.9-4.6-5.3-8.6-10-11.3c-7.9-4.5-17.5-3.9-24.5,0.9L62.8,119.6z" />
    <path d="M177.1,54.4c-0.8-0.8-1.4-1.9-1.4-3.1c0-2.4,1.9-4.3,4.2-4.3l63.8,0.1c6.5,0.1,10.4,18.3,6.1,32.7c-4.1,13.3-16.2,30.5-21.9,24.7L177.1,54.4z" />
  </svg>
)
const ForwardRef = forwardRef(SpeleologyIcon)
export { ForwardRef as ReactComponent }
